import { Box } from '@mui/material';
import { MedicalNote, MedicalNoteActivity, MedicalNoteType, User } from '@uplift/api';
import { DischargeSummaryReviewSection } from './DischargeSummaryReviewSection.component';
import { MedicalNoteSubmittedBy } from '../MedicalNoteSubmittedBy.component';
import { useMemo } from 'react';
import { PsychiatryDischargeNoteCourseOfTreatmentSections } from './PsychiatryCourseOfTreatmentReviewSections.component';
import { TherapyDischargeNoteCourseOfTreatmentSections } from './TherapyCourseOfTreatmentReviewSections.component';

export type DischargeNoteReviewProps = {
  note: MedicalNoteActivity<MedicalNoteType.psychiatryDischargeNote | MedicalNoteType.therapyDischargeNote>;
  provider: Pick<User, 'firstName' | 'lastName'>;
};

export const DischargeNoteReview: React.VFC<DischargeNoteReviewProps> = props => {

  const courseOfTreatmentReview = useMemo(() => {
    if (props.note.noteType === MedicalNoteType.psychiatryDischargeNote) {
      return <PsychiatryDischargeNoteCourseOfTreatmentSections courseOfTreatment={props.note.courseOfTreatment} />;
    }

    return <TherapyDischargeNoteCourseOfTreatmentSections courseOfTreatment={props.note.courseOfTreatment} />;
  }, [ props.note.courseOfTreatment, props.note.noteType ]);

  return (
    <Box display="flex" flexDirection="column" gap="24px" pt={3}>

      {courseOfTreatmentReview}

      <DischargeSummaryReviewSection note={props.note} />

      <MedicalNoteSubmittedBy user={props.provider} submittedAt={props.note.submittedAt} />

    </Box>
  );
};

export type DischargeNoteSidebarReviewProps = {
  note: MedicalNote<MedicalNoteType.psychiatryDischargeNote | MedicalNoteType.therapyDischargeNote>;
};

export const DischargeNoteSidebarReview: React.VFC<DischargeNoteSidebarReviewProps> = props => {

  const courseOfTreatmentReview = useMemo(() => {
    if (props.note.noteType === MedicalNoteType.psychiatryDischargeNote) {
      return <PsychiatryDischargeNoteCourseOfTreatmentSections courseOfTreatment={props.note.courseOfTreatment} isSidebar />;
    }

    return <TherapyDischargeNoteCourseOfTreatmentSections courseOfTreatment={props.note.courseOfTreatment} isSidebar />;
  }, [ props.note.courseOfTreatment, props.note.noteType ]);

  return (
    <Box display="flex" flexDirection="column" gap="24px" pt={3}>
      {courseOfTreatmentReview}
    </Box>
  );
};
